import { Directive, OnDestroy, Input, Output, EventEmitter, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

export const IMAGE_LOAD = 'assets/img/img-loading.gif';
export const IMAGE_DEFAULT = 'assets/img/img-default.jpg';
export const IMAGE_ERROR = 'assets/img/file-error.png';
export const IMAGE_SIGNING = 'assets/img/img-signing.gif';

export enum ImageCacheEvent {
  CacheNotSupported = 0,
  ErrorUrlNull,
  ErrorOpenCache,
  ErrorMatchCache,
  ErrorDownload,
  DoneDownload,
  DoneCache
}

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[imageCache]'
})
export class ImageCacheDirective implements OnDestroy {
  @Output() CacheEvent = new EventEmitter<ImageCacheEvent>();
  @Output() error = new EventEmitter();

  private _imageCache: string;
  private request: Subscription;
  private canEvent = true;
  private canErrorPropag = false;

  constructor(
    private httpClient: HttpClient,
    private element: ElementRef,
    private renderer: Renderer2
  ) { }

  public ngOnDestroy(): void {
    this.destroyRequest();
  }

  public destroyRequest(): void {
    if (this.request) {
      this.canEvent = false;
      this.request.unsubscribe();
      this.request = null;
    }
  }

  @Input('imageCache')
  set imageCache(src: string) {
    this._imageCache = src;
    this.processImage();
  }

  private processImage() {
        /*if (!CacheStorage || !URL.createObjectURL) {
            this.canErrorPropag = true;
            this.srcUrl(this._imageCache, ImageCacheEvent.CacheNotSupported);
            return;
        } else*/
    if (this._imageCache === IMAGE_DEFAULT) {
      this.srcDefault(null);
      return;
    } else if (this._imageCache === IMAGE_LOAD) {
      this.srcLoading(null);
      return;
    } else if (this._imageCache === IMAGE_ERROR) {
      this.srcError(null);
      return;
    }

    if (!this._imageCache) {
      this.srcLoading(ImageCacheEvent.ErrorUrlNull);
      return;
    }

    const file = this._imageCache.split('?')[0];
    const cacheName = 'cache' + environment.version.replace(/[^\d]/g, '');

    if (!window.caches || !window.caches.open) {
      this.canErrorPropag = true;
      // this.srcDefault(null);
      this.srcUrl(this._imageCache, ImageCacheEvent.CacheNotSupported);
      return;
    }

    window.caches.open(cacheName).then(cache => {
      const bFileUrl = this.createObjectURL(file);
      cache.match(bFileUrl).then(resp => {
        if (resp) {
          resp.blob()
            .then(fileBlob => this.createObjectURL(fileBlob))
            .catch(error => {
              console.log('window.caches.open-blob.catch', error);
              this.srcError(ImageCacheEvent.ErrorMatchCache);
            });
        } else {
          console.log('Sem resposta do cache...');
        }
      }).catch(error => {
        // console.log('window.caches.open-catch', error);
        this.destroyRequest();
        this.sendEvent(ImageCacheEvent.ErrorMatchCache);

        const headers = new HttpHeaders({ 'no-xhrbackend': 'true' });

        // TODO: Verificar retorno Blob
        this.request = this.httpClient.get<Blob>(this._imageCache, { headers })
          .subscribe(res => {
            this.sendEvent(ImageCacheEvent.DoneDownload);

            const fileBlob = res;
            const bUrl = this.createObjectURL(fileBlob);
            fetch(bUrl).then(r => cache.put(file, r));
          }, () => {
            console.log('Erro no request da imagemCache');
            this.srcError(ImageCacheEvent.ErrorDownload);
          });
      });
    }).catch(() => {
      this.canErrorPropag = true;
      this.srcUrl(this._imageCache, ImageCacheEvent.ErrorOpenCache);
    });
  }

  private createObjectURL(fileBlob) {
    const objectURL = URL.createObjectURL(fileBlob);
    this.srcUrl(objectURL, ImageCacheEvent.DoneCache);
    return objectURL;
  }

  public srcLoading(event: ImageCacheEvent) {
    this.srcUrl(IMAGE_LOAD, event);
  }

  public srcDefault(event: ImageCacheEvent) {
    this.srcUrl(IMAGE_DEFAULT, event);
  }

  public srcError(event: ImageCacheEvent) {
    this.srcUrl(IMAGE_ERROR, event);
  }

  public srcUrl(src: string, event: ImageCacheEvent) {
    this.renderer.removeClass(this.element.nativeElement, 'loading');
    this.renderer.setAttribute(this.element.nativeElement, 'src', src);
    this.sendEvent(event);
  }

  private sendEvent(event: ImageCacheEvent) {
    if (this.canEvent && event) {
      this.CacheEvent.emit(event);
    }
  }

  @HostListener('error', ['$event'])
  public onError(event) {
    console.log('Error listener', this.canErrorPropag);
    if (this.canErrorPropag) {
      this.sendEvent(ImageCacheEvent.ErrorDownload);
    }
  }
}
